import { statTierClass, type StatTier } from "../../utils/playerStatTiers";

interface StatValueProps {
  value: number | undefined;
  formatted: string;
  tier: StatTier;
  className?: string;
}

export const StatValue = ({ formatted, tier, className }: StatValueProps) => (
  <span className={[statTierClass(tier), className].filter(Boolean).join(" ")}>{formatted}</span>
);
